import { render } from "./ListeCollectionPage.vue?vue&type=template&id=2a8c1bf0&ts=true"
import script from "./ListeCollectionPage.vue?vue&type=script&lang=ts"
export * from "./ListeCollectionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__